module.exports = __webpack_public_path__ + "static/media/moydvor_logo.42915ddb.svg";